import moment, { Moment } from 'moment';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import './generate-form.scss';
import { ReportType } from 'types/report';
import api from 'api';
import { useForm } from 'react-hook-form';
import Dates from '../../project/filters-menu/dates';
import { toast } from 'react-toastify';
import { SECTION_REQUEST_LOG } from '../report-modal';

function GenerateForm({
    report,
    setSection
} : {
    report: ReportType,
    setSection: (data: number) => void,
}) {
    const state = useSelector((state: RootState) => state);
    const [loading, setLoading] = useState<boolean>(false);
    const [dateFrom, setDateFrom] = useState<Moment>(moment().subtract(1, 'd').set('h', 0).set('m', 0).set('s', 0));
    const [dateTo, setDateTo] = useState<Moment>(moment().set('h', 23).set('m', 59).set('s', 59));
    
    const { handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async (data:any) => {
        var request = {
            ReportId : report.Id,
            DateEnd : dateTo.set('h', 23).set('m', 59).set('s', 59).format("DD MMM YYYY HH:mm"),
            DateStart : dateFrom.format("DD MMM YYYY HH:mm")
        }
        setLoading(true);
        await api.report.generate(request)
        .then(() => {
            toast.success("Report successfully generated"); return; 
        }).catch(err => {
            toast.error(err.toString());
        })
        .finally(() =>{
            setLoading(false);
            setSection(SECTION_REQUEST_LOG);
        })     
        if (errors) {
            toast.warn(errors);
        } 
    }

    const quickDateSelect = useCallback((val: number) => {
        switch (val) {
            case 1:
                setDateFrom(moment().set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 23).set('minutes', 59).set('seconds', 59));
                break;
            case 2: 
                setDateFrom(moment().subtract(1, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 0).set('minutes', 0).set('seconds', 0).subtract(1, 'second'));
                break;
            case 3: 
                setDateFrom(moment().subtract(1, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 23).set('minutes', 59).set('seconds', 59));
                break;
            case 4: 
                setDateFrom(moment().subtract(6, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 23).set('minutes', 59).set('seconds', 59));
                break;
            case 5: 
                setDateFrom(moment().subtract(13, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 23).set('minutes', 59).set('seconds', 59));
                break;
            case 6: 
                setDateFrom(moment().subtract(29, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 23).set('minutes', 59).set('seconds', 59));
                break;
            case 7: 
                setDateFrom(moment().set('date', 1).set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('hours', 23).set('minutes', 59).set('seconds', 59));
                break;
            case 8: 
                setDateFrom(moment().subtract(1, 'month').set('date', 1).set('hours', 0).set('minutes', 0).set('seconds', 0));
                setDateTo(moment().set('date', 1).set('hours', 0).set('minutes', 0).set('seconds', 0).subtract(1, 'second'));
                break;
        }
    }, [setDateFrom, setDateTo])

    return (        
        <div id={'generate-form'} className="form-container">
            <h2>{'GENERATE'}</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h4>Summary</h4>
                <div className='summary'>
                    <div>
                        Report Name: {report.Name}
                    </div>
                    <div>
                        Project Id(s): {report.BinIds.toString()}
                    </div>
                    <div>
                        Streams: 
                        <ul>
                            {state.core.Stream.filter(x => report.StreamIds.includes(x.Id)).map((item, idx) => {
                                return <li key={idx}>{item.Description}</li>
                            })}
                        </ul>
                    </div>
                    <div>
                        Templates: 
                        <ul>
                            {state.reportOptions.TemplateOptions.filter(x => report.TemplateIds.includes(x.Id)).map((item, idx) => {
                                return <li key={idx}>{item.Name}</li>
                            })}
                        </ul>
                    </div>
                    <div>
                        Contacts: 
                        <ul>
                            {state.clientContacts.filter(x => report.RecipientIds.includes(x.Id)).map((item, idx) => {
                                return <li key={idx}>{item.Name}</li>
                            })}
                        </ul>
                    </div>
                    <div>
                        Layout: {state.reportOptions.LayoutOptions.find(x => x.Id === report.LayoutId)?.Description}
                    </div>
                </div>
                <div className="filters-section date">
                    <p className="filters-section-heading">Date Range</p>
                    <Dates dateFrom={dateFrom} setDateFrom={setDateFrom} dateTo={dateTo} setDateTo={setDateTo} quickDateSelect={quickDateSelect} />
                </div>

                <button className="button" type="submit">{loading ? <i className="fal fa-spinner fa-spin"></i> : <span>SUBMIT</span> }</button>
            </form>
        </div>
    )
}

export default GenerateForm;